import {
  GrapeMeasureValues,
  RanchSummaryTableGrapeRow,
} from '../hooks/useGenerateRanchSummaryTableGrapeRows';
import { GrapeColumnEnum } from '../RanchSummaryTableGrape';

/**
 * Retrieves the displayed Grape value for a given row, measure, and column.  'Per Meter', 'Per Plant', and 'Total Count' are all available, but only one is displayed at a time depending on the user's selection.
 *
 * @param row - The row data of type `RanchSummaryTableGrapeRow`.
 * @param measure - The measure key of type `keyof GrapeMeasureValues`.
 * @param column - The column key of type `GrapeColumnEnum`.
 * @returns The value corresponding to the specified measure and column, or `null` if the column values are not an object.
 */
export const getDisplayedGrapeValue = (
  row: RanchSummaryTableGrapeRow,
  measure: keyof GrapeMeasureValues,
  column: GrapeColumnEnum
) => {
  if (!row) {
    console.debug('Row is undefined in getDisplayedGrapeValue');
    return null;
  }

  const columnValues = row[column];

  if (
    columnValues === null ||
    columnValues === undefined ||
    typeof columnValues !== 'object'
  ) {
    console.debug(
      `Column ${column} not found in row or is an invalid object. Row:`,
      row
    );
    return null;
  }

  return columnValues[measure];
};
